import React from 'react';
import PropTypes from 'prop-types';
import type { ContactCardProps } from './ContactCard.types';
import Icon from '../../icon/Icon'
import './contactCard.scss';

const ContactCard = ({ avatar, name, description, information }: ContactCardProps) => {
  return (
    <div
      className="sb-contactCard"
      data-testid="sb-contactCard"
    >
      <div
        className="sb-contactCard__container"
        data-testid="sb-contactCard__container"
      >
        <img
          className="sb-contactCard__image"
          data-testid="sb-contactCard__image"
          src={avatar}
          alt={name}
        />
        <div
          className="sb-contactCard__content"
          data-testid="sb-contactCard__content"
        >
          <p
            className="sb-contactCard__content--name"
            data-testid="sb-contactCard__content--name"
          >
            {name}
          </p>
          <p
            className="sb-contactCard__content--description"
            data-testid="sb-contactCard__content--description"
          >
            {description}
          </p>
        </div>
      </div>
      <div
        className="sb-contactCard__information"
        data-testid="sb-contactCard__information"
      >
        {information?.map((info, index) =>
        (
          <div
            className="sb-contactCard__information--item"
            data-testid="sb-contactCard__information--item"
            key={`sb-contactCard__information--item-${index}`}
          >
            <Icon iconName={info.iconName} size={12} className="mr-xxlg" />
            <div
              className="sb-contactCard__information--content"
              data-testid="sb-contactCard__information--content"
            >
              <p>{info.title}</p>
              <p
                className="sb-contactCard__information--text"
                data-testid="sb-contactCard__information--text"
              >
                {info.text}
              </p>
            </div>
          </div>
        )
        )}
      </div>
    </div>
  );
};

ContactCard.propTypes = {
  /**
 * avatar
 */
  avatar: PropTypes.string,
  /**
* name
*/
  name: PropTypes.string,
  /**
* description
*/
  description: PropTypes.string,
};

ContactCard.defaultProps = {
  avatar: "https://i.ibb.co/QKkpfgc/user-image-2.png",
  name: "Maria Rodríguez",
  description: "UTP12345678",
  information:
    [
      {
        iconName: "mail",
        title: "Email",
        text: "nombreapellido@utp.edu.pe",
      },
      {
        iconName: "book",
        title: "Curso",
        text: "Gestión del talento humano",
      }
    ]
};

export default ContactCard;